import { stringify } from 'csv-stringify';
import MessageDialog from '../libs/message-dialog/';
import moment from 'moment';

function removeId(data) {
  return data.map(({ _id, ...rest }) => rest);
}

function checkAndEncryptAPIKey(data) {
  const list = ['api_keys.full.key', 'api_keys.readonly.key'];

  for (let element of list) {
    if (data.hasOwnProperty(element)) {
      data[element] =
        data[element].slice(0, 4) + 'XXXX' + data[element].slice(-4);
    }
  }

  return data;
}

function changeAPIkey(element, data) {
  data[element] = data[element] ? 'not-empty' : 'empty';

  return data;
}

function checkAndChangeAPIKey(data) {
  const list = [
    'api_keys.full.secret',
    'api.keys.readonly.secret',
    'api_keys.readonly.password',
    'api_keys.readonly.password_encrypted',
    'api_keys.full.secret_encrypted',
    'api_keys.readonly.secret_encrypted',
    'api_keys.full.id',
    'api_keys.full.password',
    'api_keys.full.password_encrypted',
    'api_keys.readonly.id'
  ];

  for (let element of list) {
    if (data.hasOwnProperty(element)) {
      changeAPIkey(element, data);
    }
  }

  return data;
}

function changeCredential(data) {
  const list = ['credential.secreat', 'credential.secret_encrypted'];

  for (let element of list) {
    if (data.hasOwnProperty(element)) {
      changeAPIkey(element, data);
    }
  }
  return data;
}

function addressesTransform(data) {
  data = data.map(changeCredential);
  return data;
}

function accountTransform(data) {
  data = data.map(checkAndEncryptAPIKey);
  data = data.map(checkAndChangeAPIKey);

  return data;
}

export async function exportCsv(items, collection, page) {
  const result = {};
  let fieldsToRemove = ['_id'];

  let data = removeId(items);

  if (collection === 'accounts') {
    data = accountTransform(data);
  }

  if (collection === 'addresses') {
    data = addressesTransform(data);
  }

  stringify(
    data,
    {
      header: true
    },
    (err, output) => {
      try {
        const link = document.createElement('a');
        link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(output);
        link.download = `${collection}_${moment(new Date()).format(
          'YYYY-MM-DD--HH-mm-ss'
        )}_page_${page}.csv`;
        link.click();
        MessageDialog.showSuccessMessage({
          title: 'Export Complete',
          text: `Export ${data.length} records, Page ${page}`
        });
      } catch (err) {
        MessageDialog.showErrorMessage({ title: 'Export Error', text: err });
      }
    }
  );
}

export async function exportBotReportCsv(items, name, exchange = 'All') {
  if (exchange === null) {
    exchange = 'All';
  }
  if (items) {
    const csvData = items.result.map((data) => data.split(','));
    stringify(
      csvData,
      {
        header: true,
        columns: ['Date', 
        'From Date',
        'From Date (UTC)',
        'To Date', 
        'To Date (UTC)',
        'exchange', 
        'Base Token', 
        'Quote Token', 
        'Bot ID', 
        'Balance Base', 
        'Balance Quote', 
        '24HR Market Volume (Base)', 
        '24HR Market Volume (Quote)', 
        '24HR Market Volume (USD)', 
        'Total 24HR Bot Volume (Base Raw)', 
        'Total 24HR Bot Volume (Base)', 
        'Total 24HR Bot Volume (Quote)', 
        'Total 24HR Bot Volume (USD)', 
        'Volume Made Sold Amount (Base)', 
        'Bought Amount (Base)', 
        'Sold Amount (Quote)', 
        'Bought Amount (Quote)', 
        'Fees (Base)', 
        'Fees (Quote)', 
        'Average', 
        'Price Sell', 
        'Average Price Buy',
        'Number of Trades (Buy)', 
        'Number of Trades (Sell)', 
        'Remark']
      },
      (err, output) => {
        try {
          const link = document.createElement('a');
          link.href =
            'data:text/csv;charset=utf-8,' + encodeURIComponent(output);
          link.download = `${name}_${exchange}_${moment(new Date()).format(
            'YYYY-MM-DD--HH-mm-ss'
          )}_.csv`;
          link.click();
          console.log('Export Complete');
        } catch (err) {
          MessageDialog.showErrorMessage({ title: 'Export Error', text: err });
        }
      }
    );
  }
}
